// src/utils/format.js
// Agregar esta funcion si no existe en tu proyecto

/**
 * Formatea un numero como moneda (Guaranies)
 * @param {number} amount - Monto a formatear
 * @param {string} currency - Simbolo de moneda (default: Gs.)
 * @returns {string} Monto formateado
 */
export const formatCurrency = (amount, currency = 'Gs.') => {
	if (amount === null || amount === undefined) return '-'
	
	const formatted = new Intl.NumberFormat('es-PY', {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	}).format(amount)
	
	return `${currency} ${formatted}`
}

/**
 * Formatea un numero con separador de miles
 * @param {number} num - Numero a formatear
 * @returns {string} Numero formateado
 */
export const formatNumber = (num) => {
	if (num === null || num === undefined) return '-'
	
	return new Intl.NumberFormat('es-PY').format(num)
}